import angular from 'angular';
import uiRouter from 'angular-ui-router';
import operativeSpendingsComponent from './operative-spendings.component';
import dataTable from 'angular-material-data-table';

let operativeSpendingsModule = angular.module('operativeSpendings', [
    uiRouter,
    dataTable
])
.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('operativeSpendings', {
        url: '/operative-spendings?quoteId',
        component: 'operativeSpendings',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('operativeSpendings', operativeSpendingsComponent)
.name;

export default operativeSpendingsModule;
